<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { deviceJudgment } from "@/utils/index.js";
export default {
  name: "App",
  data() {
    return {
      mobile: deviceJudgment(),
    };
  },
  created() {
  },
  computed: {

  },
};
</script>

<style>
body {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding-right: 0 !important;
}
.notice {
  font-size: 25px !important;
  .el-notification__group {
    .el-notification__title {
      font-size: 25px !important;
    }
  }
}
</style>
